var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.49,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23 14.3L0 20.93l3.17-1.57 1.57 3.17 2.23-6.64M14.74 14.3l2.23 6.63-3.17-1.57-1.57 3.17L10 15.89M8.49 4l1.3 2.63 2.9.43-2.1 2.05.5 2.89-2.6-1.37L5.89 12l.49-2.89-2.1-2.05 2.91-.43z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "static/media/certified.cd60c327273986564e6f2c9ff87b324c.svg";
export { ForwardRef as ReactComponent };